<script setup lang="ts">
const showPopup = defineModel('showPopup');
</script>

<template>
  <div class="wrong-sex-card">
    <p>已收到您的問題，將有專人於一個工作日內致電協助您，謝謝</p>

    <button @click="showPopup = false">確定</button>
  </div>
</template>

<style lang="scss" scoped>
/** style */
.wrong-sex-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 138px;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  align-items: center;
  justify-content: space-between;
  p {
    color: #191919cc;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
  }
  button {
    width: 100%;
    border: none;
    background-color: #f74768;
    color: #ffffff;
    font-size: 16px;
    border-radius: 4px;
    padding: 8px 24px;
    cursor: pointer;
  }
}

.junior-landing-page > .main-content > .popup-overlay > .wrong-sex-card > button {
  background-color: $color-brownish-100;
}
</style>
